<!--<v-dialog  class="pa-0 display-unset" v-model="dialog" width="700">-->
<template>
  <div class="">
    <v-container class="">
      <v-layout row wrap align-center>
        <v-flex offset-xs0 offset-lg2 class="text-xs-center" xs12 lg7>
          <v-flex xs12 lg12>
            <router-link :to="'/teacherprofile/'+teacherId+'#calender'"><v-icon class="textColor left">keyboard_arrow_left</v-icon></router-link>
            <h1 class="f-20 mb-2 font-weight-bold">Edit Event</h1>
          </v-flex>
          <v-card class="card-r no-shadow pa-2 ">
            <v-layout row wrap class="">
              <v-flex>
                  <v-alert
                    :value="true"
                    v-if="alertType"
                    :type="alertType"
                    >
                    {{msg}}
                  </v-alert>
              </v-flex>
              <div class="f-15 w-100 text-xs-left text-grey font-weight-bold">Select Date</div>
              <v-flex d-flex lg12 xs12 class="pa-2">
                <HotelDatePicker
                v-if="event.start_date"
                  format="YYYY-MM-DD"
                  :startingDateValue="new Date(event.start_date)"
                  :endingDateValue="new Date(event.end_date)"
                  @check-in-changed="checkInChanged($event)"
                  @check-out-changed="checkOutChanged($event)">
                  >
                </HotelDatePicker>
              </v-flex>
              <!-- {{event.start_date}} -->
            </v-layout>
            <v-divider></v-divider>
            <!--</v-flex>-->
            <!--</v-layout>-->
            <v-flex d-flex lg12 xs12 class="mt-3">
              <v-autocomplete outline
                  v-model="event.selectedPlan"
                  prepend-icon="alarm"
                  :items="items"
                  class="pa-2"
                  label="whats is your plan"
                  placeholder="select your plan">
              </v-autocomplete>
            </v-flex>
            <v-flex xs12 lg12 class="text-xs-right pa-2">
              <v-btn @click="UpdateEvent"  class="h-50p w-100 ma-0 text-white no-shadow card-r text-xs-right" color="primary">Update Event</v-btn>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  /* eslint-disable */
  import HotelDatePicker from 'vue-hotel-datepicker'
  import api from "@/utils/backend-api"
  import router from "@/router"
  export default {
    data () {
      return {
        model: false,
        items:['sick','holiday','vacation','leave'],
        teacherId:'',
        eventdialog:false,
        eventId:'',
        event:{
          start_date:'',
          end_date:'',
          selectedPlan:''
        },
        alertType:'',
        msg:''
      }
    },
    created:function(){
      this.eventId=this.$route.params.id
      this.teacherId=this.$route.params.teacherId
      this.editEventPopup(this.eventId)
    },
    methods:{
      UpdateEvent(){
        this.loading=true
        this.alertType=""
        this.msg=""
        let self=this
        let TeacherId=this.$route.params.teacherId
        let data={
            title:this.event.selectedPlan,
            start_date:this.event.start_date,
            end_date:this.event.end_date,
            teacher_id:TeacherId,
            event_id:this.selectedEventId
        }
        console.log(data)
        if(this.event.start_date!=null && this.event.end_date!=null){
          if(this.event.selectedPlan!=null){
              api.postData('admin/adminUpdateEvent',data)
              .then(res=>{
                  if(res.status==201){
                    this.alertType="success"
                    this.msg="Your event successfully updated"
                    this.loading=false
                    setTimeout(function(){
                      let teacherId=self.teacherId
                      router.push({ path: `/teacherprofile/${teacherId}/#calender` }) // -> /user/123
                    }, 1200);
                  }else{
                    this.alertType="error"
                    this.msg="Event updation failed. Please check your values"
                    this.loading=false
                  }
              }).catch(err=>{
                    this.alertType="error"
                    this.msg="Event updation failed"
                    this.loading=false
              })
          }else{
            this.alertType="error"
            this.msg="Please enter your plan"
            this.loading=false
          }
        }else{
            this.alertType="error"
            this.msg="Please Choose dates"
            this.loading=false
        }
      },
      checkInChanged(date){
        this.event.start_date=this.convertDate(date)
      },
      checkOutChanged(date){
        this.event.end_date=this.convertDate(date)
      },
      convertDate(date){
        var date = new Date(date),
        mnth = ("0" + (date.getMonth()+1)).slice(-2),
        day  = ("0" + date.getDate()).slice(-2);
        return [ date.getFullYear(), mnth, day ].join("-");
      },
      editEventPopup(eventId){
        this.sheet=false
        this.selectedEventId=eventId
          console.log("Hello",eventId)
          api.getData('admin/adminGetEvent/'+eventId)
          .then(res=>{
            if(res.status==200){
              this.event.start_date=res.data.start_date
              this.event.end_date=res.data.end_date
              this.event.selectedPlan=res.data.title
            }
          }).catch(err=>{
            // this.eventAlert="warning"
          //   this.eventMsg="Event deletion is failed"
          })
          this.eventEditPopup=true
      },
    },
    components: {
      HotelDatePicker,
    },
  }
</script>
<style>
  .datepicker__input {
    -webkit-appearance: none !important;
  }
  .datepicker__close-button {
    top: 10px!important;
    font-weight: unset!important;
    font-size: 30px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/test/EditEvent.vue